import * as React from 'react';
// TODO: deep import is bad, fix importing from index
import Link from '@wix/thunderbolt-elements/components/Link';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import classNames from 'clsx';
import { getLayoutClass } from '../../../../CollapsibleText.utils';
import type {
  Classes,
  ICollapsibleTextControllerProps,
  ExpandControlData,
  ExpandControlProps,
  WithLogicalLayout,
  ExpandButtonComponentProps,
} from '../../../../CollapsibleText.types';
import styles from '../CollapsibleText.module.scss';
import { ExpandModeValues, TestIds } from '../../../../constants';
import semanticClassNames from '../../../../CollapsibleText.semanticClassNames';
import extendedStyles from '../extendedStyleApi.module.scss';

const buttonSemanticClassName = formatClassNames(semanticClassNames.button);

export type ExpandControlCompProps = ExpandControlData &
  ExpandControlProps &
  ICollapsibleTextControllerProps &
  Classes &
  WithLogicalLayout &
  ExpandButtonComponentProps;

export const ExpandControl: React.FC<ExpandControlCompProps> = ({
  link,
  linkText,
  expandMode,
  readMoreText,
  readLessText,
  textDescription,
  isExpanded,
  partToPreviewStateMap,
  extendedStyleApi = true,
  setIsExpanded,
  reportBiOnExpandClick,
  reportBiOnLinkClick,
  withLogicalLayout = false,
  classes,
  ExpandButtonComponent,
}) => {
  const onExpandClick = () => {
    setIsExpanded(!isExpanded);
    reportBiOnExpandClick(!isExpanded);
  };

  const onLinkClick = () => {
    reportBiOnLinkClick();
  };

  const className = classNames(
    styles['expand-control'],
    styles[getLayoutClass(withLogicalLayout)],
    buttonSemanticClassName,
    classes?.expandControl,
    { [extendedStyles['expand-control']]: extendedStyleApi },
  );

  switch (expandMode) {
    case ExpandModeValues.Expand:
      return ExpandButtonComponent ? (
        <ExpandButtonComponent
          onClick={onExpandClick}
          label={isExpanded ? readLessText : readMoreText}
        />
      ) : (
        <button
          className={className}
          onClick={onExpandClick}
          data-testid={TestIds.viewer.expand_control}
          data-preview={partToPreviewStateMap?.button}
          aria-expanded={isExpanded}
          aria-label={textDescription}
        >
          {isExpanded ? readLessText : readMoreText}
        </button>
      );
    case ExpandModeValues.Link:
      return ExpandButtonComponent ? (
        <ExpandButtonComponent label={linkText} link={link} />
      ) : (
        <Link
          {...link}
          onClick={onLinkClick}
          aria-label={textDescription}
          className={className}
          dataTestId={TestIds.viewer.expand_control}
          dataPreview={partToPreviewStateMap?.button}
        >
          {linkText}
        </Link>
      );
    default:
      return null;
  }
};
